// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"castle-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 4C14.7614 4 17 6.23858 17 9V21H7V9C7 6.23858 9.23858 4 12 4Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M22 21V14C22 11.7909 20.2091 10 18 10H17V21H22Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M2 21H7V10H6C3.79086 10 2 11.7909 2 14V21Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 21V16M22 14V21H17V10H18C20.2091 10 22 11.7909 22 14ZM7 21H2V14C2 11.7909 3.79086 10 6 10H7V21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 4C9.23858 4 7 6.23858 7 9H17C17 6.23858 14.7614 4 12 4ZM12 4V3M7 9.85V21H17V9.85","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Castle2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'castle-2',
    ref,
    icon: element,
  },
));

Castle2Icon.displayName = 'Castle2Icon';

export default Castle2Icon;
